import { render, staticRenderFns } from "./StockDetail.vue?vue&type=template&id=020749c0&scoped=true&"
import script from "./StockDetail.vue?vue&type=script&lang=js&"
export * from "./StockDetail.vue?vue&type=script&lang=js&"
import style0 from "./StockDetail.vue?vue&type=style&index=0&id=020749c0&prod&lang=scss&scoped=true&"
import style1 from "./StockDetail.vue?vue&type=style&index=1&id=020749c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020749c0",
  null
  
)

export default component.exports